import { useState, useEffect } from "react";
import "./challenge-reports.css";
import ChallengeReportQuestionItem from "./ChallengeReportQuestionItem";
import ChallengeReportPlayerItem from "./ChallengeReportPlayerItem";
//
import { FaPercent, FaRegQuestionCircle } from "react-icons/fa";
import { GoClock } from "react-icons/go";
import { FaUsers } from "react-icons/fa";
//
import { onGetChallengeReports } from "../../../services/challenge";
import Swal from "sweetalert2";
import { convertDuration } from "../../../../../core/utils/helpers";
import useAxiosPrivate from "../../../../../app/providers/context-provider/useAxiosPrivate";

const ChallengeReports = ({ challenge_id }) => {
  const axiosPrivate = useAxiosPrivate();

  const [isQuestionsReport, setIsQuestionsReport] = useState(true);
  const [challengeReportsData, setChallengeReportsData] = useState({});

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    const localData = {
      challenge_id: challenge_id,
      report_type: isQuestionsReport ? "questions" : "players",
    };

    onGetChallengeReports(axiosPrivate, localData, signal)
      .then((response) => {
        console.log({ "CHA-REPORT": response });
        const _data = response?.data?.result;
        //
        setChallengeReportsData(_data);
      })
      .catch((error) => {
        if (!error?.response) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No server response",
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Warning",
            text: error?.response?.data?.message,
          });
        }
      });

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [isQuestionsReport]);

  return (
    <div className="w-full h-full challenge-reports">
      <div className="challenge-reports-head">
        <div className="c-r-h-tile">
          <FaPercent className="icon" />
          <div className="col">
            <span>Global Success rate</span>
            <h1>{challengeReportsData?.challenge_global_success_rate}%</h1>
          </div>
        </div>
        <div className="c-r-h-tile">
          <FaRegQuestionCircle className="icon" />
          <div className="col">
            <span>Total Questions</span>
            <h1>{challengeReportsData?.challenge_total_questions}</h1>
          </div>
        </div>
        <div className="c-r-h-tile">
          <GoClock className="icon" />
          <div className="col">
            <span>Duration</span>
            <h1>
              {convertDuration(challengeReportsData?.challenge_total_duration)}
            </h1>
          </div>
        </div>
        <div className="c-r-h-tile">
          <FaUsers className="icon" />
          <div className="col">
            <span>Total Players</span>
            <h1>{challengeReportsData?.challenge_total_players}</h1>
          </div>
        </div>
      </div>
      <div className="challenge-reports-tab">
        <button
          className={isQuestionsReport ? "button active fade-in" : "button"}
          onClick={() => setIsQuestionsReport(true)}
        >
          Report by Question
        </button>
        <button
          className={!isQuestionsReport ? "button active fade-in" : "button"}
          onClick={() => setIsQuestionsReport(false)}
        >
          Report by Player/Team
        </button>
      </div>
      <div className="challenge-reports-body">
        {isQuestionsReport ? (
          <>
            <div className="c-r-b-item">
              <ChallengeReportQuestionItem />
            </div>
            <div className="c-r-b-item">
              <ChallengeReportQuestionItem />
            </div>
            <div className="c-r-b-item">
              <ChallengeReportQuestionItem />
            </div>
          </>
        ) : (
          <>
            <div className="c-r-b-item">
              <ChallengeReportPlayerItem />
            </div>
            <div className="c-r-b-item">
              <ChallengeReportPlayerItem />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ChallengeReports;
